import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import ChequeAddForm from "../../components/Cheque/Add/ChequeAddForm";

const ChequeAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "افزودن چک ",
            to: "/cheque/add",
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <ChequeAddForm />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ChequeAddPage;
